import samplesImg from "@/assets/home-overzicht-drukwerk.webp";
import { Button } from "@/components/ui/button";
import { BadgeEuro, MessageCircle } from "@/components/Icon";

const About = () => (
  <section id="over-ons" className="py-20 md:py-28">
    <div className="container">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold leading-tight text-[#0a2933]">
            T-shirts bedrukken en kleding laten bedrukken in{" "}
            Den Haag
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            Wilt u een t-shirt laten bedrukken in Den Haag of zoekt u een specialist in kleding bedrukken en textieldruk? Bij Magic Print bent u aan het juiste adres voor het professioneel bedrukken en borduren van textiel. Wij verzorgen textielbedrukking voor bedrijven, verenigingen, evenementen en particulieren.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Bij ons kunt u onder andere T-shirts, sweaters, polo's, hoodies, caps en bedrijfskleding laten bedrukken. In onze textieldrukkerij in Den Haag werken wij met moderne apparatuur en verschillende druktechnieken, waardoor wij hoge kwaliteit leveren tegen scherpe prijzen. Van 10 tot 10.000 stuks.
          </p>
          <div className="flex flex-wrap gap-3 pt-2">
            <Button asChild>
              <a href="https://www.magicprint.nl/aanbiedingen/" target="_blank" rel="noopener noreferrer">
                <BadgeEuro className="mr-2 w-4 h-4" /> Bekijk aanbiedingen
              </a>
            </Button>
            <Button variant="outline" asChild>
              <a href="https://wa.me/31652526002" target="_blank" rel="noopener noreferrer">
                <MessageCircle className="mr-2 w-4 h-4" /> WhatsApp ons
              </a>
            </Button>
          </div>
        </div>
        <div className="relative">
          <img
            src={samplesImg}
            alt="Overzicht drukwerk en bedrukte kleding"
            className="rounded-2xl shadow-2xl w-full"
            loading="lazy"
            width={1200}
            height={800}
          />
          <div className="absolute -bottom-4 -left-4 bg-primary text-primary-foreground px-6 py-3 rounded-xl font-heading font-bold text-lg shadow-lg">
            Sinds 1994
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
